import 'core-js/modules/es.string.replace-all'
import 'core-js/modules/es.array.at.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { createPortal } from 'react-dom';
import styled from 'styled-components'
import { GlobalStyle } from '@/App/style';

import { Menu, Footer } from '@niimko/drupal_menu'
import { getStoreData } from '@/helpers'

let { drupalHost, translationDay, allMenuLinks, currentAct }:any = getStoreData();

if (global.location.pathname.includes('fepo_pro')) {
    currentAct = 'fepo_pro'
}
if (global.location.pathname.includes('test_constructor')) {
    currentAct = 'test_constructor'
}

import ThemeContext, { themes } from '@/theme/context'

import { HeaderComponent } from '@/components/Header'

const Wrapper = styled.div`
    height: 45px;
`

ReactDOM.createRoot(document.getElementById('headerMenu'))
.render(
    <ThemeContext.Provider value={themes[currentAct || 'default']} >
        <HeaderComponent drupalHost={drupalHost} currentAct={currentAct} translationDay={translationDay} />
        <Wrapper>
            <Menu allMenuLinks={allMenuLinks} drupalHost={drupalHost} currentAct={currentAct} isInnerPage={true}/>
        </Wrapper>
        {createPortal(<Footer currentAct={currentAct}/>, document.getElementById('footer')!)}
        <GlobalStyle />
    </ThemeContext.Provider>
)